import { render, staticRenderFns } from "./changePsd.vue?vue&type=template&id=65edd6ba&"
import script from "./changePsd.vue?vue&type=script&lang=js&"
export * from "./changePsd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports